import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _extends from "@babel/runtime/helpers/esm/extends";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import React, { useState, useEffect, useRef } from "react";
import { connect } from "react-redux";
import { withFormik } from "formik";
import * as yup from "yup";
import { accountHelper, formatter } from "../../util";
import * as UTIL from '../../util';
import axios from 'axios';
import moment from 'moment';
import { Loading } from '../state';
import { Container, Row, Col, Button, FormGroup, Tab, Tabs } from "react-bootstrap";
import Heading from "../heading/Heading";
import Wrapper from "../wrapper/Wrapper";
import Modal from "../modal/Modal";
import { Modal as BootstrapModal } from "react-bootstrap";
import { FormikWizardProvider, Wizard, StepsList, Step, ButtonsList, PreviousButton, NextButton, SubmitButton } from "formik-wizard-form"; // Validation schema

import { validation, required } from "./util/validation";
import InlineError from '../state/InlineError';
import ContactInfo from "./ContactUs/ContactInfo";
import ExperienceInfo from "./ContactUs/ExperienceInfo";
import StoreLocation from "./ContactUs/StoreLocation";
import Questions from "./ContactUs/Questions";
import OnlineOrder from "./ContactUs/OnlineOrder"; // Redux

import { waitlistDuck } from "../../ducks/waitlist";
var waitlistOperations = waitlistDuck.operations;

function Parent(_ref) {
  var children = _ref.children,
      props = _objectWithoutProperties(_ref, ["children"]);

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      show = _useState2[0],
      setShow = _useState2[1];

  var handleClose = function handleClose() {
    return setShow(false);
  };

  var handleShow = function handleShow() {
    return setShow(true);
  };

  var handleRedirect = function handleRedirect() {
    window.location = "/";
  };

  return /*#__PURE__*/React.createElement("div", null, children(show, handleShow, handleClose, handleRedirect));
}

var contactUsURL = UTIL.apiUtil.generateUrl('guest-relations', 'createContactUsTicket');
var formikEnhancer = withFormik({
  enableReinitialize: true,
  mapPropsToValues: function mapPropsToValues(props) {
    return {
      firstName: props.firstName,
      lastName: props.lastName,
      emailAddress: props.emailAddress,
      phoneNumber: props.phoneNumber,
      streetAddress: props.streetAddress,
      userZipCode: props.userZipCode,
      city: props.city,
      state: props.state,
      termsAndConditions: props.termsAndConditions,
      newsletter: props.newsletter,
      feedbackConcern: props.feedbackConcern,
      visitDate: props.visitDate,
      partySize: props.partySize,
      receiptNumber: props.receiptNumber,
      feedbackText: props.feedbackText,
      isFetching: props.isFetching,
      storelocation: props.storelocation.location
    };
  },
  validationSchema: yup.object().shape({
    feedbackConcern: required("Please give your feedback"),
    feedbackText: required("Please give your feedback"),
    firstName: validation.firstName,
    lastName: validation.lastName,
    emailAddress: validation.emailAddress,
    phoneNumber: validation.phoneNumber,
    userZipCode: validation.zipCode,
    termsAndConditions: required("Please review and accept terms")
  }),
  handleSubmit: function handleSubmit(values, _ref2) {
    var setSubmitting = _ref2.setSubmitting;
    setTimeout(function () {
      // alert(JSON.stringify(values, null, 2));
      setSubmitting(false);
    }, 1000);
    axios({
      method: 'post',
      url: contactUsURL,
      headers: UTIL.apiUtil.setHeaders(),
      params: {
        subject: values.feedbackConcern,
        name: values.firstName + ' ' + values.lastName,
        phone: values.phoneNumber,
        "00N6f00000FebOE": values.storelocation.clientkey,
        "00N6f00000FebNy": moment(values.visitDate).format("MM/DD/YYYY h:mm a"),
        "00N6f00000FebO2": values.partySize,
        "00N6f00000FebNf": values.receiptNumber,
        description: values.feedbackText,
        email: values.emailAddress,
        "00N6f00000FebOI": values.streetAddress,
        "00N6f00000FebNg": values.city,
        "00N6f00000FebOC": values.state,
        "00N6f00000FebOL": values.userZipCode
      }
    }).then(function (response) {
      //handle success
      console.log(response);
    }).catch(function (response) {
      //handle error
      console.log(response);
    });
  },
  displayName: "ContactUs" // helps with React DevTools

});

var ContactUs = function ContactUs(props) {
  var values = props.values,
      touched = props.touched,
      errors = props.errors,
      dirty = props.dirty,
      isSubmitting = props.isSubmitting,
      handleChange = props.handleChange,
      handleBlur = props.handleBlur,
      handleSubmit = props.handleSubmit,
      handleReset = props.handleReset,
      store = props.store,
      err = props.err,
      showForm = props.showForm,
      isLoading = props.isLoading,
      location = props.location,
      isFetching = props.isFetching,
      _props$disclaimer = props.disclaimer,
      disclaimer = _props$disclaimer === void 0 ? {} : _props$disclaimer,
      toggleForm = props.toggleForm,
      checkWaitlistAvailable = props.checkWaitlistAvailable,
      getWaitlist = props.getWaitlist,
      setFieldValue = props.setFieldValue;
  var ExperienceValidation = errors.partySize || errors.feedbackText || errors.feedbackConcern || errors.firstName || errors.lastName || errors.userZipCode || errors.emailAddress || errors.phoneNumber || errors.termsAndConditions;
  useEffect(function () {
    getWaitlist();
  }, []);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Wrapper, {
    className: "cb-content-block--solid cb-l-padding-small--vertical"
  }, /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement(Row, {
    className: ""
  }, /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement("h2", {
    className: "text-center cb-type__title"
  }, "TELL US ABOUT YOUR EXPERIENCE"), /*#__PURE__*/React.createElement(Tabs, {
    defaultActiveKey: "Restaurant Experience",
    className: "mt-16 flex-column flex-md-row"
  }, /*#__PURE__*/React.createElement(Tab, {
    eventKey: "Restaurant Experience",
    title: "RESTAURANT EXPERIENCE",
    className: "mt-16"
  }, /*#__PURE__*/React.createElement(Row, {
    className: "mt-16"
  }), /*#__PURE__*/React.createElement(Row, {
    className: "mt-16"
  }), /*#__PURE__*/React.createElement(Row, {
    className: "mt-16"
  }, /*#__PURE__*/React.createElement(React.Fragment, null,
  /*#__PURE__*/

  /* {(location && !location.data) &&  */
  React.createElement(FormikWizardProvider, _extends({}, props, {
    enableReinitialize: true
  }), function (_ref3) {
    var getValidators = _ref3.getValidators,
        otherProps = _objectWithoutProperties(_ref3, ["getValidators"]);

    return /*#__PURE__*/React.createElement(Wizard, otherProps, /*#__PURE__*/React.createElement(StepsList, null, /*#__PURE__*/React.createElement(Step, _extends({
      component: StoreLocation,
      store: store,
      title: "Store Location",
      location: location,
      isFetching: isFetching,
      changeHandler: props.changeHandler
    }, props)), /*#__PURE__*/React.createElement(Step, _extends({
      component: ExperienceInfo,
      title: "Experience Info",
      changeHandler: props.changeHandler
    }, props)), /*#__PURE__*/React.createElement(Step, _extends({
      component: ContactInfo,
      title: "Guest Information",
      changeHandler: props.changeHandler
    }, props))), /*#__PURE__*/React.createElement(ButtonsList, null, /*#__PURE__*/React.createElement(PreviousButton, {
      className: "cb-button-secondary"
    }), /*#__PURE__*/React.createElement(NextButton, {
      className: "cb-button-primary"
    }), /*#__PURE__*/React.createElement(SubmitButton, null, /*#__PURE__*/React.createElement(Parent, null, function (show, handleShow, handleClose, handleRedirect) {
      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Button, {
        type: "submit",
        disabled: ExperienceValidation,
        onClick: function onClick(e) {
          return handleShow(true);
        },
        className: "cb-button-primary"
      }, "Submit"), /*#__PURE__*/React.createElement(Modal, {
        show: show,
        hide: handleClose,
        title: "THANK YOU"
      }, /*#__PURE__*/React.createElement(BootstrapModal.Body, {
        classname: "text-center"
      }, /*#__PURE__*/React.createElement("p", null, "Thank you for contacting Cracker Barrel Old Country Store. Your feedback is very important to us so we\u2019ll get back to you as soon as possible.")), /*#__PURE__*/React.createElement(BootstrapModal.Footer, null, /*#__PURE__*/React.createElement(Button, {
        className: "cb-button-primary",
        onClick: handleRedirect
      }, "Return Home"))));
    }))));
  })))), /*#__PURE__*/React.createElement(Tab, {
    eventKey: "questions",
    title: "QUESTIONS/SUGGESTIONS",
    className: "mt-16"
  }, /*#__PURE__*/React.createElement(Row, {
    className: "mt-16"
  }), /*#__PURE__*/React.createElement(Row, {
    className: "mt-16"
  }), /*#__PURE__*/React.createElement(Row, {
    className: "mt-16"
  }, /*#__PURE__*/React.createElement(React.Fragment, null,
  /*#__PURE__*/

  /* {(location && !location.data) &&  */
  React.createElement(FormikWizardProvider, _extends({}, props, {
    enableReinitialize: true
  }), function (_ref4) {
    var otherProps = Object.assign({}, _ref4);
    return /*#__PURE__*/React.createElement(Wizard, otherProps, /*#__PURE__*/React.createElement(StepsList, null, /*#__PURE__*/React.createElement(Step, _extends({
      component: Questions,
      title: "Feedback",
      changeHandler: props.changeHandler
    }, props)), /*#__PURE__*/React.createElement(Step, _extends({
      component: ContactInfo,
      title: "Guest Information",
      changeHandler: props.changeHandler
    }, props))), /*#__PURE__*/React.createElement(ButtonsList, null, /*#__PURE__*/React.createElement(PreviousButton, {
      className: "cb-button-secondary"
    }), /*#__PURE__*/React.createElement(NextButton, {
      className: "cb-button-primary"
    }), /*#__PURE__*/React.createElement(SubmitButton, null, /*#__PURE__*/React.createElement(Parent, null, function (show, handleShow, handleClose, handleRedirect) {
      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Button, {
        type: "submit",
        disabled: ExperienceValidation,
        onClick: function onClick(e) {
          return handleShow(true);
        },
        className: "cb-button-primary"
      }, "Submit"), /*#__PURE__*/React.createElement(Modal, {
        show: show,
        hide: handleClose,
        title: "THANK YOU"
      }, /*#__PURE__*/React.createElement(BootstrapModal.Body, {
        classname: "text-center"
      }, /*#__PURE__*/React.createElement("p", null, "Thank you for contacting Cracker Barrel Old Country Store. Your feedback is very important to us so we\u2019ll get back to you as soon as possible.")), /*#__PURE__*/React.createElement(BootstrapModal.Footer, null, /*#__PURE__*/React.createElement(Button, {
        className: "cb-button-primary",
        onClick: handleRedirect
      }, "Return Home"))));
    }))));
  })))), /*#__PURE__*/React.createElement(Tab, {
    eventKey: "online",
    title: "ONLINE RETAIL ORDER",
    className: "mt-16"
  }, /*#__PURE__*/React.createElement(Row, {
    className: "mt-16"
  }), /*#__PURE__*/React.createElement(Row, {
    className: "mt-16"
  }), /*#__PURE__*/React.createElement(Row, {
    className: "mt-16"
  }, /*#__PURE__*/React.createElement(React.Fragment, null,
  /*#__PURE__*/

  /* {(location && !location.data) &&  */
  React.createElement(FormikWizardProvider, _extends({}, props, {
    enableReinitialize: true
  }), function (_ref5) {
    var getValidators = _ref5.getValidators,
        otherProps = _objectWithoutProperties(_ref5, ["getValidators"]);

    return /*#__PURE__*/React.createElement(Wizard, otherProps, /*#__PURE__*/React.createElement(StepsList, null, /*#__PURE__*/React.createElement(Step, _extends({
      component: OnlineOrder,
      title: "Online Order",
      changeHandler: props.changeHandler
    }, props)), /*#__PURE__*/React.createElement(Step, _extends({
      component: ContactInfo,
      title: "Guest Information",
      changeHandler: props.changeHandler
    }, props))), /*#__PURE__*/React.createElement(ButtonsList, null, /*#__PURE__*/React.createElement(PreviousButton, {
      className: "cb-button-secondary"
    }), /*#__PURE__*/React.createElement(NextButton, {
      className: "cb-button-primary"
    }), /*#__PURE__*/React.createElement(SubmitButton, null, /*#__PURE__*/React.createElement(Parent, null, function (show, handleShow, handleClose, handleRedirect) {
      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Button, {
        type: "submit",
        disabled: ExperienceValidation,
        onClick: function onClick(e) {
          return handleShow(true);
        },
        className: "cb-button-primary"
      }, "Submit"), /*#__PURE__*/React.createElement(Modal, {
        show: show,
        hide: handleClose,
        title: "THANK YOU"
      }, /*#__PURE__*/React.createElement(BootstrapModal.Body, {
        classname: "text-center"
      }, /*#__PURE__*/React.createElement("p", null, "Thank you for contacting Cracker Barrel Old Country Store. Your feedback is very important to us so we\u2019ll get back to you as soon as possible.")), /*#__PURE__*/React.createElement(BootstrapModal.Footer, null, /*#__PURE__*/React.createElement(Button, {
        className: "cb-button-primary",
        onClick: handleRedirect
      }, "Return Home"))));
    }))));
  }))))))))), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Tabs, null, /*#__PURE__*/React.createElement("div", {
    label: "Restaurant Experience"
  }), /*#__PURE__*/React.createElement("div", {
    label: "Two"
  }), /*#__PURE__*/React.createElement("div", {
    label: "Sarcosuchus"
  }, "Nothing to see here, this tab is ", /*#__PURE__*/React.createElement("em", null, "extinct"), "!"))));
};

var mapStateToProps = function mapStateToProps(state) {
  var _state$account;

  var account = accountHelper((_state$account = state.account) === null || _state$account === void 0 ? void 0 : _state$account.aadResponse);
  return {
    account: state.account,
    storelocation: state.location,
    showForm: state.waitlist.showForm,
    zipCode: state.waitlist.zipCode,
    results: state.waitlist.results,
    confirmation: state.waitlist.confirmation,
    storeId: state.waitlist.storeId,
    isError: state.error.isError,
    err: state.error.err
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return _defineProperty({
    toggleForm: function toggleForm() {
      return dispatch(waitlistOperations.toggleForm());
    },
    changeHandler: function changeHandler(e) {
      return dispatch(waitlistOperations.changeInput(e));
    },
    getWaitlist: function getWaitlist() {
      return dispatch(waitlistOperations.getWaitlist());
    }
  }, "toggleForm", function toggleForm() {
    return dispatch(waitlistOperations.toggleForm());
  });
};

export default connect(mapStateToProps, mapDispatchToProps)(formikEnhancer(ContactUs));